<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const value = computed(() => {
  if (!Array.isArray(props.data) || props.data.length === 0) return []
  return props.data
})
</script>

<template>
  <div class="table-cell flex gap-1">
    <Tag v-for="(item, idx) in value" class="!font-[300] !text-[11px] whitespace-nowrap" :key="`badge-${idx}`" :value="item.label" :severity="item.type"></Tag>
  </div>
</template>

<style scoped>

</style>
